import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { array, concat } from '@ember/helper';
import t from 'ember-intl/helpers/t';
import type { Signature as ForcProviderBaseSignature } from 'parog-web/components/forc/provider/base';

interface Signature {
  Args: {
    form: ForcProviderBaseSignature['Blocks']['default'][0];
  };
}

const MiciBaseConsultFormAnalIncontinenceFrequency: TemplateOnlyComponent<Signature> =
  <template>
    {{#if @form.changeset.analIncontinence}}
      <@form.FieldsRadioGroup
        @propertyName='analIncontinenceFrequency'
        @title={{t 'mici-form.analIncontinenceFrequency.long' htmlSafe=true}}
        as |Group|
      >
        {{#each (array '0' '1' '2' '3') as |value|}}
          <Group.FieldRadio
            @value={{value}}
            @label={{t
              (concat 'mici-form.analIncontinenceFrequency.answers.' value)
            }}
          />
        {{/each}}
      </@form.FieldsRadioGroup>
    {{/if}}
  </template>;

export default MiciBaseConsultFormAnalIncontinenceFrequency;
